import { translate } from 'vue-gettext'

const { pgettext } = translate

const PaymentPlatform = {
    IOS: {
        value: 'ios',
        label: pgettext('edge-payment.platform', 'Apple'),
        icon: 'cibApple'
    },
    ANDROID: {
        value: 'android',
        label: pgettext('edge-payment.platform', 'Android'),
        icon: 'cibAndroid'
    },
    WEB: {
        value: 'web',
        label: pgettext('edge-payment.platform', 'Website'),
        icon: 'cilGlobeAlt'
    },
    EDGE_APP: {
        value: 'edge_app',
        label: pgettext('edge-payment.platform', 'App'),
        icon: 'cilMobile'
    },
    EDGE_TOTEM: {
        value: 'edge_totem',
        label: pgettext('edge-payment.platform', 'Totem'),
        icon: 'cilMediaPlay'
    },
    EDGE_POS: {
        value: 'edge_pos',
        label: pgettext('edge-payment.platform', 'POS'),
        icon: 'cilCash'
    },
    OTHER: {
        value: 'other',
        label: pgettext('edge-payment.platform', 'Other'),
        icon: 'cilOptions'
    },
    UNKNOWN: {
        value: 'unknown',
        label: pgettext('edge-payment.platform', 'Unknown'),
        icon: 'cilHelpCircle'
    }
}

export default PaymentPlatform

export const getPaymentPlatformOptions = () => {
    return Object.values(PaymentPlatform).map(platform => ({
        value: platform.value,
        label: platform.label
    }))
}

export const getPaymentPlatformByValue = (value) => {
    return Object.values(PaymentPlatform).find(p => p.value === value)
}

export const getPaymentPlatformLabel = (platform) => {
    const platformObj = getPaymentPlatformByValue(platform)
    return platformObj ? platformObj.label : platform
}

export const getPaymentPlatformIcon = (platform) => {
    const platformObj = getPaymentPlatformByValue(platform)
    return platformObj ? platformObj.icon : 'cilOptions'
}

export const getPaymentPlatformFilterOptions = () => {
    // Only include edge_app and edge_totem
    const platforms = Object.values(PaymentPlatform)
        .filter(p => p.value === 'edge_app' || p.value === 'edge_totem')
        .map(platform => ({
            value: platform.value,
            label: platform.label
        }))

    return [
        { value: '', label: pgettext('edge-payment.platform', 'All') },
        ...platforms
    ]
}
